export const GARDEN_CENTER = {
  address: 'МО, г.о. Егорьевск, д. Синевая',
  phone: '+7 (926) 096-34-75',
  botUsername: 'sova_sad_centr_bot',
  telegramUrl: 'https://t.me/SoVa_sad_centr',
  maxUrl: 'https://max.ru/u/f9LHodD0cOIJ_h_tHZn_BDankAebXcBYcJFau-uMfitrTjQfOBDagf9aUPw',
  telegramChannelUrl: 'https://t.me/sova_sad_centr_mo',
  maxChannelUrl: 'https://max.ru/id772157869068_biz',
  websiteUrl: 'https://sova-sad-centr.ru/',
  yandexMapsUrl: 'https://yandex.ru/maps/org/sova/220959437948/?ll=39.245174%2C55.428078&z=17',
  yandexReviewsUrl: 'https://yandex.ru/maps/org/sova/220959437948/reviews/?ll=39.245174%2C55.428078&z=17',
  workingHours: 'Понедельник — Воскресенье с 9:00 до 19:00',
  workingHoursShort: 'Пн–Вс 9:00–19:00',
  about: 'Мы — семейный садовый центр и питомник So.Va. С любовью выращиваем растения уже более 15 лет. Каждое растение получает индивидуальный уход и внимание. Наши специалисты помогут подобрать идеальные растения для вашего сада, дачи или дома.',
};
